import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-i', 'LetterI', [["path",{"d":"M12 4l0 16"}]]);